import { Map, Record } from "immutable";
import { IWidgetType } from "constants/media";

const defaults = {
    component_type: undefined,
    display_properties: Map<string, string>(),
    rich_text: Map<string, string>(),
    ref_id: undefined,
    customer_groups: [],
    widget_subtype: "",
};

export class PageLayoutComponent extends Record(defaults) {
    declare ref_id: string;
    declare component_type: string;
    declare display_properties: Map<string, string>;
    declare rich_text: Map<string, string>;
    declare customer_groups: string[];
    declare widget_subtype: IWidgetType;

    constructor(args) {
        super({
            ...args,
            display_properties: Map(args.display_properties),
            rich_text: Map(args.rich_text),
        });
    }
}
